import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setDropoff } from '../actions/shipback'

import { isEmpty } from '../assets/utils'
import { COMPUTED } from '../assets/constant'

import GoogleMap from './GoogleMap'
import Dropoff from './Dropoff'
import DropoffSelected from './DropoffSelected'

class DropoffModal extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.state = {}
    this.dismiss = this.dismiss.bind(this)
    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this)
  }

  submit() {
    if (this.props.shipback.dropoff_code == undefined && this.props.selectedDropoff == null){
      this.props.setDropoff(this.props.dropoff.dropoff_points[0].id, this.props.shipback.id, this.props.user_token)
    } else {
      this.props.setDropoff(this.props.selectedDropoff.id, this.props.shipback.id, this.props.user_token)
    }
    this.dismiss()
  }

  cancel() {
    if (this.props.shipback.dropoff_code == undefined) {
      this.props.resetDropoff()
    } else {
      for (var i = 0; i < this.props.dropoff.dropoff_points.length; i++) {
        var dropoff = this.props.dropoff.dropoff_points[i];
        if(dropoff.id == this.props.shipback.dropoff_code) {
          this.props.setDropoffFromMap(dropoff, i)
        }
      }
    }
    this.dismiss()
  }

  dismiss() {
    $("#edit-dropoff-modal").modal('hide');
    $('#edit-dropoff-modal').on('hidden.bs.modal', function(e){
      $('#edit-contact-button').one('focus', function(e){$(this).blur();});
    });
  }

  render() {
    if (this.props.dropoff != undefined && this.props.dropoff.state == COMPUTED && this.props.dropoff.dropoff_points) {
      return (
        <div className="modal" id="edit-dropoff-modal" tabIndex="-1" role="dialog" aria-labelledby="edit-dropoff-modal" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <h2>{I18n.t('shipbacks.modes.dropoffs.modal.title')}</h2>
                <div id="dropoff-map">
                  <GoogleMap selectedDropoff={this.selectedDropoff} selectDropoff={this.props.setDropoffFromMap} />
                </div>
                {
                  !isEmpty(this.props.selectedDropoff)  ?
                  <DropoffSelected dropoff={this.props.selectedDropoff} dropoffIndex={this.props.dropoffIndex} modal={true} />
                  :
                  <DropoffSelected dropoff={this.props.dropoff.dropoff_points[0]} dropoffIndex={this.props.dropoffIndex} modal={true} />
                }
                <div className="col-12 actions mb-3 mt-3">
                  <a className="submit" onClick={this.submit}>
                   {I18n.t('shipbacks.modes.dropoffs.modal.title')}
                  </a>
                </div>
                <div className="col-12 actions">
                  <a onClick={this.cancel} className="dismiss">{I18n.t('shipbacks.modes.dropoffs.modal.cancel')}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else if (this.props.dropoff && !this.props.dropoff.dropoff_points) {
      return (
          <div className="row spinner">
          <div className="col-12">
            <h3>{I18n.t('shipbacks.modes.dropoffs.none')}</h3>
          </div>
        </div>
      )
    } else {
      return (
        <div className="row spinner">
          <div className="col-12">
            <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.modes.dropoffs.fetching.title')}</h3>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
 dropoff: state.quotes.dropoff,
 user_token: state.user,
 shipback: state.shipback
})

const mapDispatchToProps = dispatch => bindActionCreators({ setDropoff }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DropoffModal)


// WEBPACK FOOTER //
// ./app/javascript/components/components/DropoffModal.jsx